simpleTest = require 'lib/experiments/simple-test'
t = require('views/internal/teacup-with-helpers')('power_up_item')

powerUpItemTemplateWithTaglines = ({ iconSrc, canEnable, upgradeUrl, displayName, upsellEnabled, details }) ->
  t.div '.power-up-item-header', ->
    t.div '.power-up-item-icon', ->
      t.img '.power-up-item-icon-image.mod-rounded', { src: iconSrc, alt: "Power-Up Icon" }

    t.div '.power-up-item-details', ->

      t.h4 '.power-up-item-details-header.js-show-details', ->
        t.text displayName

    t.div '.power-up-item-actions', ->

      t.a '.power-up-item-actions-button.mod-settings.js-show-settings', { href: '#' }, ->
        t.icon 'gear'

      if canEnable

        if upsellEnabled
          if upgradeUrl
            t.a '.power-up-item-actions-button.mod-upgrade.button-link.mod-button-link', { href: upgradeUrl }, ->
              t.format 'upgrade'

          if !upgradeUrl
              t.a '.power-up-item-actions-button.mod-upgrade.button-link.mod-button-link.js-add-to-team', ->
                t.format 'upgrade'

        t.a '.power-up-item-actions-button.mod-enable.button-link.primary.js-enable', { href: '#' }, ->
          t.format 'enable'

        t.a '.power-up-item-actions-button.mod-disable.button-link.negate.js-disable', { href: '#' }, ->
          t.format 'disable'

        if upsellEnabled
          t.a '.power-up-item-actions-button.mod-fake-enable.button-link.primary.js-fake-enable', { href: '#' }, ->
            t.format 'enable'

  t.div '.power-up-item-tagline.js-show-details', ->
    t.text getTagline(details)

getTagline = (powerUpDetails) ->
  firstSentence = powerUpDetails.split(/\.\s|\.{3}|…/, 1)[0].trim()

  return "#{firstSentence.substring(0, 95).trim()}…"

defaultPowerUpItemTemplate = ({ iconSrc, displayName, canEnable, upgradeUrl, upsellEnabled }) ->
  t.div '.power-up-item-icon', ->
    t.img '.power-up-item-icon-image.mod-rounded', { src: iconSrc, alt: "Power-Up Icon" }
    t.icon 'check', { class: 'power-up-item-enabled-icon' }

  t.div '.power-up-item-details', ->

    t.h4 '.power-up-item-details-header.js-show-details', ->
      t.text displayName
      t.icon 'information', { class: 'power-up-item-details-info-icon' }

  t.div '.power-up-item-actions', ->

    t.a '.power-up-item-actions-button.mod-settings.button-link.js-show-settings', { href: '#' }, ->
      t.icon 'gear'

    if canEnable
      if upsellEnabled
        if upgradeUrl
          t.a '.power-up-item-actions-button.mod-upgrade.button-link', { href: upgradeUrl }, ->
            t.format 'upgrade'

        if !upgradeUrl
            t.a '.power-up-item-actions-button.mod-upgrade.button-link.js-add-to-team', ->
              t.format 'upgrade'

      t.a '.power-up-item-actions-button.mod-enable.button-link.js-enable', { href: '#' }, ->
        t.format 'enable'

      t.a '.power-up-item-actions-button.mod-disable.button-link.js-disable', { href: '#' }, ->
        t.format 'disable'

      if upsellEnabled
        t.a '.power-up-item-actions-button.mod-fake-enable.button-link.js-fake-enable', { href: '#' }, ->
          t.format 'enable'

module.exports = t.renderable ({ iconSrc, displayName, canEnable, upgradeUrl, upsellEnabled, details }) ->
  data = { iconSrc, displayName, canEnable, upgradeUrl, upsellEnabled, details }

  if simpleTest('powerUpTaglines')?.get('showTaglines')
    return powerUpItemTemplateWithTaglines(data)

  return defaultPowerUpItemTemplate(data)



// WEBPACK FOOTER //
// ./app/scripts/views/templates/power_up_item.coffee